module.exports = __webpack_public_path__ + "img/deskshelf24.ec22b403.jpg";